var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tagName,_vm._g({ref:"editable",tag:"component",attrs:{"contenteditable":""}},_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }